"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyNameMapping = void 0;
exports.keyNameMapping = {
    enter: 'Enter',
    space: ' ',
    escape: 'Escape',
    tab: 'Tab',
    arrowLeft: 'ArrowLeft',
    arrowRight: 'ArrowRight',
    arrowUp: 'ArrowUp',
    arrowDown: 'ArrowDown',
    delete: 'Delete',
    backspace: 'Backspace',
};
